import Option, { Choices } from "../types/Option"

export function choicesToOptions(choices: Choices, sort = false): Option<string>[] {
    let options = Object.entries(choices).map(([value, label]) => ({ label, value }))

    if (sort) {
        options = options.sort((a, b) => a.label.localeCompare(b.label))
    }

    return options
}

export function addressToDirectionsLink(address: string) {
    const encodedAddress = encodeURIComponent(address)

    return `https://www.google.com/maps/dir/?api=1&destination=${encodedAddress}`
}
